import { render, staticRenderFns } from "./sales-invoices-tab.vue?vue&type=template&id=840dcea6&scoped=true"
import script from "./sales-invoices-tab.vue?vue&type=script&lang=js"
export * from "./sales-invoices-tab.vue?vue&type=script&lang=js"
import style0 from "./sales-invoices-tab.vue?vue&type=style&index=0&id=840dcea6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840dcea6",
  null
  
)

export default component.exports